import { HttpMethod, httpClient } from './http-client';
import {
  InteractionRuleObject,
  InteractionTemplate,
  TriggerPointTypeListResponse,
} from '../@types/interaction.type';

export interface EventTypeResponse {
  code: string;
  name: string;
}

export const createInteractionRule = (interactionRule: InteractionRuleObject): Promise<InteractionRuleObject> => {
  return httpClient<InteractionRuleObject>('/interactionRules', HttpMethod.Post, interactionRule);
};

export const updateInteractionRule = (id: number, interactionRule: InteractionRuleObject): Promise<InteractionRuleObject> => {
  return httpClient<InteractionRuleObject>(`/interactionRules/${id}`, HttpMethod.Put, interactionRule);
};

export const getAllInteractionTemplates = (): Promise<InteractionTemplate> => {
  return httpClient<InteractionTemplate>('/interactionTemplates', HttpMethod.Get);
};

export const getAllTriggerPointTypes = (): Promise<TriggerPointTypeListResponse[]> => {
  return httpClient<TriggerPointTypeListResponse[]>('/triggerPointTypes', HttpMethod.Get);
};

export const getAllEventTypes = (): Promise<EventTypeResponse[]> => {
  return httpClient<EventTypeResponse[]>('/eventType', HttpMethod.Get);
};
